<template>
    <span>
        <img :src="getUrl()" :style="{'height': fontSize}">
    </span>
</template>

<script>
import { PosicaoIcone } from "../../class/posicao-icone";

export default {
    name: "IconColor",
    props: {
        ign: {
            default: 'OFF'
        },
        icon: {
            default: 'car'
        },
        colorIgnOff: {
            default: 'car'
        },
        fontSize: {
            default: '18px'
        }
    },
    methods: {
        getUrl () {
            return '/assets/img/icons/' + PosicaoIcone.analiseColor(this.ign, this.colorIgnOff) + '/' + this.icon + '.png'
        }
    }
}
</script>
